import React from 'react';

const ConfirmLessonCard = (props) => (
  <div className="ConfirmLesson d-flex justify-content-center">
    <div className="card mb-4 mt-4">
      <div className="row">
        <div className="col-12 text-center">
          {props.children}
        </div>
      </div>
    </div>
  </div>
);

export default ConfirmLessonCard;



// WEBPACK FOOTER //
// ./src/components/ConfirmLessonCard/index.js